import { on, TanokDispatcher, rethrowFx, debounce } from 'tanok';
import { t } from 'c-3po';
import { fromJS } from 'immutable';

import { Config } from './../../core/config';
import * as c from './../../libs/constants';
import * as a from './../../libs/actions';
import * as u from './../../libs/utils';
import {
    getProductPortalUrl
} from '../../libs/helpers/prom';
import {
    authenticateUser,
    loadServerPow,
    registerUser,
} from '../../libs/transport';

// remove in the nearest future
const formTrackers = {
    auth: null,
    register: null,
};

export class AuthDispatcher extends TanokDispatcher {
    @on(a.EVENT_AUTH_CHANGE_TAB)
    authChangeTab({ tabName }, state) {
        const { CONTENT_POWER_ENABLED } = Config.data.appState;

        const updState = state.set('activeAuthTab', tabName);

        if ((updState.get('activeAuthTab') === c.CHAT_AUTH_REGISTER || (
            updState.get('activeAuthTab') === c.CHAT_AUTH_LOGIN
            )) && CONTENT_POWER_ENABLED) {
            return [updState, loadServerPow];
        }

        return [updState];
    }

    @on(a.TR_LOAD_SERVER_POW_SUCCESS)
    loadServerPowSuccess({ powInit, powPath }, state) {
        let updState = state.set('pow', fromJS({ comp: powInit.comp, pref: powInit.pref }));
        if (state.getIn(['launchOnce', 'powClientScript']) || window.powSolve) return [updState];
        updState = updState.setIn(['launchOnce', 'powClientScript'], true);
        u.appendPowScript(powPath);
        return [updState];
    }

    @on(a.TR_LOAD_SERVER_POW_FAIL)
    loadServerPowFail(_, state) {
        let updState = state.set('pow', fromJS({ comp: null, pref: null }));
        updState = state.setIn(['activeAuthTab'], c.CHAT_AUTH_SOCIAL);
        return [updState];
    }

    @on(a.EVENT_AUTH_PHONE_EMAIL_CHANGE)
    authPhoneEmailChange({ value }, state) {
        formTrackers.auth.first_use('email');
        const updState = state.setIn(['loginFields', 'phoneEmail'], value);
        return [updState];
    }

    @on(a.EVENT_AUTH_PASSWORD_CHANGE)
    authPasswordsChange({ value }, state) {
        formTrackers.auth.first_use('password');
        const updState = state.setIn(['loginFields', 'password'], value);
        return [updState];
    }

    @on(a.TR_AUTHENTICATE_USER, debounce(500))
    authenticateUser(_, state) {
        const { CONTENT_POWER_ENABLED } = Config.data.appState;

        let updState = state.set('fieldsErrors', fromJS({}));

        if (updState.getIn(['isLoadingData', 'login'])) return [updState];
        if (!window.powSolve && CONTENT_POWER_ENABLED) return [updState];

        updState = updState.setIn(['isLoadingData', 'login'], true);

        CONTENT_POWER_ENABLED && (
            updState = updState.setIn(
                ['pow', 'nonce'],
                window.powSolve(
                    updState.getIn(['pow', 'comp']),
                    updState.getIn(['pow', 'pref'])
                ))
        );

        return [updState, authenticateUser([
            `phone_email=${updState.getIn(['loginFields', 'phoneEmail'])}`,
            `password=${updState.getIn(['loginFields', 'password'])}`,
            `pow_complexity=${updState.getIn(['pow', 'comp'])}`,
            `pow_prefix=${updState.getIn(['pow', 'pref'])}`,
            `pow_nonce=${updState.getIn(['pow', 'nonce'])}`,
            `_save=YES`,
            location.search.substring(1)
        ].join('&'))];
    }

    @on(a.TR_AUTHENTICATE_USER_SUCCESS)
    authenticateUserSuccess(response, state) {
        const muchError = alert;
        if (response.status === 'ok' && response.action === 'logged_in') {
            // improve module; move storage data save, outside of chat
            formTrackers.auth.submit_success();
            if (state.get('contextItemId')) {
                const productUrl = getProductPortalUrl(state.get('contextItemId'));
                window.location.href = u.sanitizeLocation(u.addGetParam(productUrl, c.CHAT_AUTO_OPEN_MARK, 1));
            } else window.location.reload();
            return [state, rethrowFx(a.TR_SEND_ANALITICS_ACTION,
                    { action: c.ANALCS_ACTION_AUTH_SUCCESS })];
        } else if (response.status === 'blocked' || response.status === 'blocked_session') {
            muchError(t`Вы превысили количество повторных отправлений.
                Попробуйте еще раз через 5 минут`);
        } else if (response.status === 'login_denied') {
            muchError(t`Отказано в доступе`);
        }
        const updState = state.setIn(['isLoadingData', 'login'], false);
        return [updState];
    }

    @on(a.TR_AUTHENTICATE_USER_FAIL)
    authenticateUserFail({ data }, state) {
        let updState = state.setIn(['isLoadingData', 'login'], false);
        updState = updState.setIn(['fieldsErrors'], fromJS(data.errors || {}));
        formTrackers.auth.validation_error(state.fieldsErrors);
        formTrackers.auth.submit_error();
        return [updState];
    }

    @on(a.EVENT_REGISTER_PASSWORD_CHANGE)
    registerPasswordsChange({ value }, state) {
        formTrackers.register.first_use('password');
        const updState = state.setIn(['registerFields', 'password'], value);
        return [updState];
    }

    @on(a.EVENT_REGISTER_EMAIL_CHANGE)
    registerEmailChange({ value }, state) {
        formTrackers.register.first_use('email');
        const updState = state.setIn(['registerFields', 'email'], value);
        return [updState];
    }

    @on(a.EVENT_REGISTER_USERNAME_CHANGE)
    registerUserNameChange({ value }, state) {
        formTrackers.register.first_use('userName');
        const updState = state.setIn(['registerFields', 'userName'], value);
        return [updState];
    }

    @on(a.EVENT_REGISTER_AGREEMENT_TOGGLE)
    registerAgreementToggle(_, state) {
        return [
            state.setIn(
                ['registerFields', 'agreement'],
                !state.getIn(['registerFields', 'agreement']))
        ];
    }

    @on(a.TR_REGISTER_USER, debounce(500))
    registerUser(_, state) {
        const { CONTENT_POWER_ENABLED } = Config.data.appState;

        let updState = state.set('fieldsErrors', fromJS({}));

        if (state.getIn(['isLoadingData', 'register'])) return [updState];
        if (!window.powSolve && CONTENT_POWER_ENABLED) return [state];

        CONTENT_POWER_ENABLED && (
            updState = updState.setIn(
                ['pow', 'nonce'],
                window.powSolve(
                    updState.getIn(['pow', 'comp']),
                    updState.getIn(['pow', 'pref'])
                ))
            );

        updState = updState.setIn(['isLoadingData', 'register'], true);

        return [updState, registerUser({
            first_name: state.getIn(['registerFields', 'userName']),
            email: state.getIn(['registerFields', 'email']),
            password: state.getIn(['registerFields', 'password']),
            is_developer: state.isDeveloper,
            is_user_reg_form: 1,
            landing_page_name: 'besida_chat',
            agreement: state.getIn(['registerFields', 'agreement']),
            subscription: false,
            pow_complexity: state.getIn(['pow', 'comp']),
            pow_prefix: state.getIn(['pow', 'pref']),
            pow_nonce: updState.getIn(['pow', 'nonce']),
            tracking_params: state.get('registerTrackAnal').toJS()
        })];
    }

    @on(a.TR_REGISTER_USER_SUCCESS)
    registerUserSuccess(_, state) {
        formTrackers.register.submit_success();
        if (state.get('contextItemId')) {
            const productUrl = getProductPortalUrl(state.get('contextItemId'));
            window.location.href = u.sanitizeLocation(u.addGetParam(productUrl, c.CHAT_AUTO_OPEN_MARK, 1));
        } else window.location.reload();
        return [state.setIn(['isLoadingData', 'register'], false)];
    }

    @on(a.TR_REGISTER_USER_FAIL)
    registerUserFail({ data }, state) {
        let updState = state.set('fieldsErrors', fromJS(data.errors || {}));

        formTrackers.register.validation_error(state.fieldsErrors);
        formTrackers.register.submit_error();

        updState = updState.setIn(['isLoadingData', 'register'], false);
        updState = updState.set('fieldsErrors', fromJS({
            ...state.fieldsErrors,
            ...(data.errors || {})
        }));
        return [updState];
    }

    @on(a.EVENT_REGISTER_REG_TRACKER)
    registerRegFormTracker({ node }, state) {
        const { FormTracker } = Config.data.deps;

        if (formTrackers.register) return [state];
        formTrackers.register = new FormTracker(
            node,
            `Form-Registration_user_chat`,
            true,
        );
        return [state];
    }

    @on(a.EVENT_REGISTER_AUTH_TRACKER)
    registerAuthFormTracker({ node }, state) {
        const { FormTracker } = Config.data.deps;

        if (formTrackers.auth) return [state];
        formTrackers.auth = new FormTracker(
            node,
            `Form-Login_user_chat`,
            true,
        );
        return [state];
    }
}
